import moment from 'moment';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import template from './tmsDatepicker.vue';

@Component({
    mixins: [template],
    components: {
        Datepicker,
    },
})
export default class TmsDatepicker extends Vue {
    @Prop({ default: '' })
    placeholder: string;

    @Prop({
        default: '',
    })
    value: any;

    @Prop({
        default: 'MM/dd/yyyy',
    })
    format: any;

    @Prop({
        default: '',
    })
    error: any;

    @Prop({
        default: 'MM/DD/YYYY',
    })
    emitFormat: any;

    @Prop({
        default: function() {
            return {};
        },
    })
    disabledDates: any;

    date: any = '';
    prError: any = '';

    @Watch('error')
    getError(val: any, oldVal: any) {
        if (val) this.prError = val;
    }

    @Watch('value')
    getValue(val: any, oldVal: any) {
        if (val) this.date = val;
        else this.date = '';
    }

    mounted() {
        this.date = this.value;
        // console.log('this.value',this.value);
    }

    doSomethingInParentComponentFunction(date: any) {
        this.$emit('input', moment(date).format(this.emitFormat));
    }

    clearContents() {
        this.$emit('input', '');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/tmsDatepicker/index.ts